enum Colors {
  Black = "black",
  Primary = "#32b0ea",
  PrimaryHover = "#288FBF",
  White = "white",
  Border = "#ddd",
  Error = "#ce0058",
  Success = "#66BB6A",
  Info = "#039BE5",
}

export { Colors };
